import React, { Component } from 'react'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import "whatwg-fetch"

import TInputForm from "../../../common/TInputForm"
import TTextareaForm from "../../../common/TTextareaForm"
import BlogLogoForm from "../BlogLogoForm"
import BlogIconForm from "../BlogIconForm"

import * as SaveStatus from '../../../../constants/SaveStatus'
import { receiveInfo } from '../../../../actions/setting/blog'
import { jsonResponseHandler } from "../../../../utils/FetchHelper"
import TSubmitButtonForm from "../../../common/TSubmitButtonForm";
import {addPrefix} from "../../../../utils/UriUtil";

@connect(state => ({
  info: state.setting.blog.info
}), dispatch => ({
  handleReceiveInfo(name, info) {
    dispatch(receiveInfo(info))
    if (TistoryGnb && TistoryGnb.updateUser) {
      TistoryGnb.updateUser(info.userTitle, info.logoUrl)
    }
  },
  dispatch
}))
class ProfileForm extends Component {

  constructor(props) {
    super(props)

    this.state = Object.assign({
      saveStatus: SaveStatus.READY,
      changed: false
    }, props.info)
  }

  @autobind
  handleChangeLogo(logoUrl) {
    this.setState({
      logoUrl: logoUrl,
      changed: this.isChangedAndValid({ logoUrl: logoUrl })
    })
  }

  @autobind
  handleDeleteLogo() {
    if(confirm('이미지를 삭제하시겠습니까?')) {
      this.setState({
        logoUrl: null,
        changed: this.isChangedAndValid({ logoUrl: null })
      })
    }
  }

  @autobind
  handleChangeIcon(url) {
    this.setState({
      iconUrl: url,
      changed: this.isChangedAndValid({ iconUrl: url })
    })
  }

  @autobind
  handleDeleteIcon() {
    if(confirm('아이콘을 삭제하시겠습니까?')){
      this.setState({
        iconUrl: null,
        changed: this.isChangedAndValid({ iconUrl: null })
      })
    }
  }

  @autobind
  handleChangeUserTitle(value) {
    this.setState({
      userTitle: value,
      changed: this.isChangedAndValid({ userTitle: value })
    })
  }

  @autobind
  handleChangeUserDescription(value) {
    this.setState({
      userDescription: value,
      changed: this.isChangedAndValid({ userDescription: value })
    })
  }

  @autobind
  handleSubmit(e) {
    e.preventDefault();

    const { name, logoUrl, iconUrl, userTitle, userDescription, saveStatus } = this.state
    const { info, handleReceiveInfo, dispatch } = this.props

    if (saveStatus === SaveStatus.DOING) {
      return
    }

    let data = {
      logoUrl, iconUrl, userTitle, userDescription
    }

    this.setState({
      saveStatus: SaveStatus.DOING
    })
    fetch(addPrefix("/manage/setting/blog/userInfo.json"), {
      method: 'post',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(jsonResponseHandler(dispatch))
      .then(() => {
        this.setState({
          saveStatus: SaveStatus.DONE,
          changed: false
        })
        handleReceiveInfo(name, Object.assign(info, data))
      })
      .catch(e => {
        console.error(e)
        this.setState({
          saveStatus: saveStatus
        })
      })
  }

  isChangedAndValid(changedInputData) {
    const changedInfo = Object.assign(this.state, changedInputData)
    const { info } = this.props

    let changed = changedInfo.logoUrl != info.logoUrl || changedInfo.iconUrl != info.iconUrl || changedInfo.userTitle != info.userTitle || changedInfo.userDescription != info.userDescription
    let valid = changedInfo.userTitle !== ''

    return changed && valid
  }

  render() {
    const { logoUrl, iconUrl, userTitle, userDescription, saveStatus, changed } = this.state
    let status = saveStatus
    if (saveStatus !== SaveStatus.DOING && changed) {
      status = SaveStatus.CAN_SUBMIT
    }

    return (
      <form className="wrap_set" onSubmit={this.handleSubmit}>

        <BlogLogoForm logo={logoUrl} onChange={this.handleChangeLogo} onDelete={this.handleDeleteLogo} />

        <fieldset className="fld_name">
          <div className="lab_tf">
            <strong className="tit_set">닉네임</strong>
            <TInputForm type="text" className="tf_blog" value={userTitle} onChange={this.handleChangeUserTitle} />
          </div>
          <div className="lab_tf">
            <strong className="tit_set">소개</strong>
            <TTextareaForm className="tf_blog" defaultValue={userDescription} onChange={this.handleChangeUserDescription} />
          </div>
        </fieldset>

        <BlogIconForm icon={iconUrl} onChange={this.handleChangeIcon} onDelete={this.handleDeleteIcon} />

        <fieldset>
          <legend className="screen_out">저장 버튼</legend>
          <TSubmitButtonForm type="submit" status={status} />
        </fieldset>
      </form>
    )
  }
}

export default ProfileForm
